import LogisticsMap from "./src/main";
LogisticsMap.install = function(Vue) {
  Vue.component(LogisticsMap.name, LogisticsMap);
};
export default LogisticsMap;
